import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	tempPhoneNumber: null,
	smsPendingTime: undefined,
	tempSelectedCity: null,
	tempMembershipType: null,
};

export const TempDataSlice = createSlice({
	name: "tempData",
	initialState,
	reducers: {
		setTempCity: (state, action) => {
			state.tempSelectedCity = action.payload;
		},

		setTempPhoneNumber(state, action) {
			return {
				...state,
				tempPhoneNumber: action.payload,
			};
		},

		setTempMembership: (state, action) => {
			state.tempMembershipType = action.payload;
		},

		clearTempData: () => {
			return initialState;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setTempCity, setTempMembership, setTempPhoneNumber, clearTempData } = TempDataSlice.actions;

export default TempDataSlice.reducer;
